import { LIST_CHAR_ALL, type ILayerBehavior, type IVectorLayerProps } from '@/version-types';

type Behaviors = Pick<ILayerBehavior, 'isTextEditable' | 'getTextInfo'>;

export const createTextBehaviors = (identity: string) => {
    const behaviors: Behaviors = {
        isTextEditable() {
            return true;
        },

        getTextInfo(layer) {
            const layerData = layer.data as IVectorLayerProps;
            const { textInfo } = layerData;

            if (!textInfo) return [];

            const { text, fontFamily } = textInfo;
            const ret: Array<{ fontFamily: string; text: string }> = [{ fontFamily, text }];

            const { listStyle } = textInfo;
            if (listStyle) ret.push({ fontFamily, text: LIST_CHAR_ALL });

            return ret;
        },
    };

    return behaviors;
};
